export default __webpack_public_path__ + "static/media/img-3472.fd56a1c8.jpeg";